module.exports = __webpack_public_path__ + "img/planet-saturn-internal.c2e45e7c.svg";